import { Moment } from 'moment'
import { useEffect, useState } from 'react'

import {
  WashingHistoryByDayTable,
  WashingHistoryByRangeDayTable,
} from '@/components/pages/WashingHistory/WashingHistoryByDay'
import FilterWashingHistoryByDay from '@/components/pages/WashingHistory/WashingHistoryByDay/Filter'
import ClientWashingHistoryHeader from '@/components/pages/WashingHistory/WashingHistoryByDay/PageHeader'
import { DateType } from '@/types'

import { useCustomers } from '../Customer/Customers.hooks'
import { useMachines } from '../Machine/Machine.hooks'
import { useWashingHistoryByDay } from './WashingHistoryByDay.hooks'

export type FilterDate = {
  type: DateType
  fromDate: Moment | null
  toDate: Moment | null
  totalFromDate: Moment | null
  totalToDate: Moment | null
}

export const defaultFilterDate: FilterDate = {
  type: DateType.NO_SELECT,
  fromDate: null,
  toDate: null,
  totalFromDate: null,
  totalToDate: null,
}

const WashingHistory = () => {
  const {
    washingHistoryResponse,
    washingHistoryByDayResponseLoading,
    getWashingHistoryByDay,
    exportExcelWashingHistoryByDay,
    exportWashingHistoryLoading,
    getWashingHistoryByRangeDay,
    exportExcelWashingHistoryByRangeDay,
    responseWashingHistoryByRangeDay,
    deleteLaundry,
    deleteLoading,
  } = useWashingHistoryByDay()

  const { getCustomers } = useCustomers()

  const { getMachines, getMachinesResponse } = useMachines()

  useEffect(() => {
    getCustomers()
    getMachines()
  }, [getCustomers, getMachines])

  const [dateFilter, setDateFilter] = useState<Moment | null>()
  const [dateRangeFilter, setDateRangeFilter] = useState<FilterDate>(defaultFilterDate)
  const [isReloadByDate, setIsReloadByDate] = useState(false)
  const [isReloadByRangeDate, setIsReloadByRangeDate] = useState(false)

  return (
    <>
      <ClientWashingHistoryHeader />
      <FilterWashingHistoryByDay
        getWashingHistoryByDay={getWashingHistoryByDay}
        getWashingHistoryByRangeDay={getWashingHistoryByRangeDay}
        setDateFilter={setDateFilter}
        dateFilter={dateFilter}
        washingMachines={getMachinesResponse || []}
        exportExcelWashingHistoryByDay={exportExcelWashingHistoryByDay}
        exportWashingHistoryByDayLoading={exportWashingHistoryLoading}
        setDateRangeFilter={setDateRangeFilter}
        dateRangeFilter={dateRangeFilter}
        exportExcelWashingHistoryByRangeDay={exportExcelWashingHistoryByRangeDay}
        isReloadByDate={isReloadByDate}
        isReloadByRangeDate={isReloadByRangeDate}
      />
      {dateFilter && (
        <WashingHistoryByDayTable
          washingHistoryByDayResponse={washingHistoryResponse}
          washingHistoryByDayResponseLoading={washingHistoryByDayResponseLoading}
          dateFilter={dateFilter}
          deleteLaundry={deleteLaundry}
          deleteLoading={deleteLoading}
          setIsReloadByDate={setIsReloadByDate}
        />
      )}

      {responseWashingHistoryByRangeDay && dateRangeFilter.fromDate && dateRangeFilter.toDate && (
        <WashingHistoryByRangeDayTable
          responseWashingHistoryByRangeDay={responseWashingHistoryByRangeDay}
          deleteLaundry={deleteLaundry}
          deleteLoading={deleteLoading}
          setIsReloadByRangeDate={setIsReloadByRangeDate}
        />
      )}
    </>
  )
}

WashingHistory.displayName = 'WashingHistory'
export default WashingHistory
